export const CustomFieldsModel = Symbol('CustomFieldsModel');
